import { useCallback, useState, useMemo } from 'react';

import { useApiClient } from '@ts-core/lib/apiClient';
import { getUploadFileClient, UploadFilePayload } from '@ts-core/core/utils/uploadFileToS3';

type UploadFileOptions = {
  onSuccess?: (data: UploadFilePayload) => void;
  headers?: Record<string, string>;
};

interface FileUploaderHookPayload {
  onUploadFile: (file: File, signUrlEndpoint: string, queryParams: Record<string, string>, options?: UploadFileOptions) => void;
  uploading: boolean;
  uploadProgress: number;
  error?: string;
  data?: UploadFilePayload;
}

export default function useFileUploader(): FileUploaderHookPayload {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState<string>();
  const [data, setData] = useState<UploadFilePayload>();
  const [progress, setProgress] = useState(0);

  const apiClient = useApiClient();
  const uploadFileClient = useMemo(() => {
    return getUploadFileClient(apiClient);
  }, [apiClient]);

  const onUploadFile = useCallback(
    async (file: File, signUrlEndpoint: string, queryParams: Record<string, string>, options?: UploadFileOptions) => {
      setUploading(true);
      setError(undefined);
      try {
        const result = await uploadFileClient(file, signUrlEndpoint, queryParams, { headers: options?.headers, onProgressUpdated: setProgress });
        setUploading(false);
        setData(result);
        options?.onSuccess?.(result);
      } catch (error) {
        console.log(error);
        setError((error as Error)?.message);
        setUploading(false);
      }
    },
    [uploadFileClient]
  );

  return {
    onUploadFile,

    uploading,
    uploadProgress: progress,
    error,
    data,
  };
}
